import { useHistory } from "react-router-dom";
import LandingPageBG from "../assets/svg/LandingPageBG.svg";
import LandingPageAction from "../components/global/LandingPageAction";
import LandingPageRightArrow from "../assets/svg/LandingPageRightArrow";
import LandingPageLayout from "../layouts/LandingPageLayout";
import ErrorBoundary from "../components/global/ErrorBoundary";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";

function LandingPage() {
  const history = useHistory();
  const { oktaAuth, authState } = useOktaAuth();
  const login = async () =>
    oktaAuth.signInWithRedirect({ originalUri: "/access/dashboard" });

  function navigateTo(screen: string) {
    return () => history.push(screen);
  }

  useEffect(() => {
    if (authState?.accessToken?.accessToken) {
      history.push("/access/dashboard");
    }
  }, [authState?.accessToken]);

  return (
    <LandingPageLayout>
      <ErrorBoundary>
        <div
          className="h-full flex flex-col bg-cover xl:bg-auto font-sans"
          style={{ backgroundImage: `url(${LandingPageBG})` }}
        >
          <section className="container m-auto flex flex-col h-full ">
            <div className="flex flex-col m-auto w-full xl:w-[60%]">
              <div className="flex mb-10">
                <LandingPageRightArrow height={50} className="mt-3" />
                <div className="mx-5 w-full">
                  <h2 className="text-landingBlue text-left font-semibold text-4xl md:text-5xl lg:text-[80px] mb-2 ">
                    Clinician
                  </h2>
                  <h2 className="text-landingBlue text-left font-semibold text-4xl md:text-5xl lg:text-[80px] mb-2 ">
                    Ordering Portal
                  </h2>
                  <h3 className="text-royalBlue text-base md:text-xl my-8 text-left font-semibold">
                    Improving health through innovative tests that guide patient
                    care
                  </h3>
                  <div className="md:flex justify-between mt-12">
                    <LandingPageAction
                      title="Existing Customer"
                      subtitle="Already have an account?"
                      buttonTitle="login"
                      buttonClassName="my-1 md:my-0 md:mr-4 md:w-3/6"
                      onClick={login}
                    />
                    <LandingPageAction
                      title="New Customer"
                      subtitle="Register for an account to begin"
                      buttonTitle="sign up"
                      buttonClassName="my-1 md:my-0 md:ml-4 md:w-3/6"
                      onClick={navigateTo("signup")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </ErrorBoundary>
    </LandingPageLayout>
  );
}

export default LandingPage;
